import { get, post } from '@api/api-client';
import type { PaginatedResponse, PaginationParams } from '@api/pagination';

export interface AuditLogResponse {
  id: string;
  entity: string;
  entityId: string;
  action: string;
  actor: string;
  changes: unknown;
  createdAt: string;
}

export interface AuditLogFilters {
  entity?: string;
  entityId?: string;
  actor?: string;
  from?: string;
  to?: string;
}

/** Fetches audit log entries with optional filters and pagination. */
export function getAuditLogs(
  filters?: AuditLogFilters,
  pagination?: PaginationParams,
): Promise<PaginatedResponse<AuditLogResponse>> {
  const params = new URLSearchParams();

  if (pagination?.page !== undefined) params.set('page', String(pagination.page));
  if (pagination?.pageSize !== undefined) params.set('pageSize', String(pagination.pageSize));
  if (filters?.entity) params.set('entity', filters.entity);
  if (filters?.entityId) params.set('entityId', filters.entityId);
  if (filters?.actor) params.set('actor', filters.actor);
  if (filters?.from) params.set('from', filters.from);
  if (filters?.to) params.set('to', filters.to);

  const query = params.toString();
  return get<PaginatedResponse<AuditLogResponse>>(`/audit-logs${query ? `?${query}` : ''}`);
}

/** Reverts an audit log action. */
export function revertAuditLog(id: string): Promise<{ reverted: boolean }> {
  return post<{ reverted: boolean }>(`/audit-logs/${id}/revert`, {});
}
